module.exports = __webpack_public_path__ + "img/header-sel-home.3556a4ac.svg";